export default __webpack_public_path__ + "static/placeholder-687922d9aa8e02d04e4f07f49b8b72bc.png";